import React, { useCallback } from "react"
import ActivityModal from "./ActivityModal"
import { ActivityModalContext } from "../context/ActivityModalContext"
import { useModal } from "gatsby-singita-theme/src/hooks"

const ActivityModalWrapper = props => {
  const [modal, toggleModal] = useModal()
  const modalCallback = useCallback(
    (contentId, contentType) => toggleModal(contentId, contentType),
    [toggleModal]
  )
  return (
    <ActivityModalContext.Provider
      value={{ modal, toggleModal: modalCallback }}
    >
      <ActivityModal {...props} />
    </ActivityModalContext.Provider>
  )
}

export default ActivityModalWrapper
